import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { filterProps } from 'foundations-components/utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ModalWrapper = props => {
  const {
    onClose,
    modalName,
    modalSubTitle,
    Header,
    Body,
    Footer,
    illustrationName,
    illustrationWidth = '350px',
    modalDataTestId,
    closeButtonDataTestId
  } = props;
  const width = illustrationName ? 900 : 800;
  const {
    tokenProps
  } = filterProps(props, {
    disallowedProps: ['display']
  });
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: width,
    "data-test-id": modalDataTestId || modalName,
    children: [modalSubTitle && /*#__PURE__*/_jsx(View, {
      position: "absolute",
      marginBlockStart: "600",
      marginInlineStart: "1000",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        textAlign: "left",
        children: modalSubTitle
      })
    }), /*#__PURE__*/_jsxs(Flex, Object.assign({}, tokenProps, {
      children: [/*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          "data-test-id": closeButtonDataTestId || `${modalName}-close-button`,
          onClick: onClose
        }), /*#__PURE__*/_jsxs(DialogBody, {
          paddingBlockStart: "1000",
          children: [Header || /*#__PURE__*/_jsx(Text, {
            as: "h1",
            textAlign: "left",
            marginBlockEnd: "600",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `embedPoints.${modalName}.title`
            })
          }), /*#__PURE__*/_jsx(Text, {
            textAlign: "left",
            children: Body
          })]
        }), /*#__PURE__*/_jsx(DialogFooter, {
          children: Footer
        })]
      }), illustrationName && /*#__PURE__*/_jsx(Box, {
        alignSelf: "center",
        children: /*#__PURE__*/_jsx(Illustration, {
          "data-test-id": "modal-illustration",
          name: illustrationName,
          width: illustrationWidth
        })
      })]
    }))]
  });
};
export default ModalWrapper;